import { BootType } from './types/BootType';
import { isBrowserEdge } from 'owa-user-agent/lib/userAgent';
import { getPackageBaseUrl } from 'owa-config';

export async function calculateBootType(startTime: number): Promise<BootType> {
    try {
        let response = await fetch(`${getPackageBaseUrl()}resources/analytics-ping.js`);
        return parseResponse(startTime, response);
    } catch {
        return 'Unknown';
    }
}

function parseResponse(startTime: number, response: Response) {
    if (response.headers.get('x-sw-active-cache')) {
        return 'SwCache';
    }

    let responseDateString = response.headers.get('Date');
    if (responseDateString == null && isBrowserEdge()) {
        // This is a workaround of an Edge bug 12359311: Date header not exposed for cached resources when fetched with CORS
        // https://microsoft.visualstudio.com/DefaultCollection/OS/_workitems?id=12359311&fullScreen=false
        // Given that edge doesn't expose "Date" header when fetch with CORS, we assume this is a BrowserCache scenario. It doesn't
        // apply to other browsers so that we won't miss the regression if we failed to parse date string in other browsers.
        // Once Edge fix this issue in RS3, we can remove this workaround safely.
        return 'BrowserCache';
    }
    let responseDateTimestamp = Date.parse(responseDateString);
    if (isNaN(responseDateTimestamp)) {
        throw new Error('Invalid Date');
    }

    // If the resource date is retrieved after the session start, so this is loaded from online
    // Given that there can be clock difference between server and browser, we allow 1000ms for the delta
    return responseDateTimestamp - startTime > -1000 ? 'NoCache' : 'BrowserCache';
}
